export default (title) => {
    document.title = title.replace(/&[^;]*;/gi, "");
}
